import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";

// ✅ Import Slices
import authReducer from "./slices/authSlice";
import allUserReducer from "./slices/allUserSlice";
import allUserRoleReducer from "./slices/allUserRoleSlice";
import allUserGroupReducer from "./slices/allUserGroupSlice";
import statesReducer from "./slices/statesSlice";
import countryReducer from "./slices/countrySlice";
import organizationMasterReducer from "./slices/organizationMasterSlice";
import entityMasterReducer from "./slices/entityMasterSlice";
import sponsorMasterReducer from "./slices/sponsorMasterSlice";
import familyOfficeMasterReducer from "./slices/familyOfficeMasterSlice";
import enumReducer from "./slices/enumSlice";
import entityTypeMasterReducer from "./slices/entityTypeMasterSlice";
import investmentMandateTypeReducer from "./slices/investmentMandateTypeSlice";
import assetTypeReducer from "./slices/assetTypeSlice";
import assetsReducer from "./slices/assetsSlice";
import investmentMasterReducer from "./slices/investmentMasterSlice";
import documentTypeReducer from './slices/documentTypeSlice';
import documentMasterReducer from './slices/documentMasterSlice';
import logsReducer from './slices/riskAssessmentLogsSlice';
import opportunityTypeReducer from './slices/opportunityTypeSlice';
import opportunityMasterReducer from './slices/opportunityMasterSlice';
import opportunityApplicationReducer from './slices/opportunityApplicationSlice';
import opportunityAllocationReducer from './slices/opportunityAllocationSlice';
import memberInterviewRecordReducer from './slices/memberInterviewRecordSlice';
import opportunityApplicationInterviewReducer from './slices/opportunityApplicationInterviewSlice';
import entityCapReducer from './slices/entityCapSlice';
import mentorshipMasterReducer from './slices/mentorshipMasterSlice';

// ✅ Import Services
import { authService } from "./services/authService";
import { allUserService } from "./services/allUserService";
import { allUserRoleService } from "./services/userRoleService";
import { allUserGroupService } from "./services/userGroupService";
import { stateService } from "./services/stateService";
import { countryService } from "./services/countryService";
import { organizationMasterService } from "./services/organizationMasterService";
import dashboardReducer from './slices/dashbordSlice';
import { dashboardService } from './services/dashboardService';
import { entityMasterService } from './services/entityMasterService';
import { sponsorMasterService } from './services/sponsorMasterService';
import { familyOfficeMasterService } from './services/familyOfficeMasterService';
import { enumService } from './services/enumService';
import { entityTypeMasterService } from './services/entityTypeMasterService';
import { investmentMandateTypeService } from './services/investmentMandateTypeService';
import { assetTypeService } from './services/assetTypeService';
import { assetsService } from './services/assetsService';
import { investmentMasterService } from './services/investmentMasterService';
import { documentTypeService } from "./services/documentTypeService";
import { documentMasterService } from "./services/documentMasterService";
import { riskAssessmentLogService } from "./services/riskAssessmentLogService";
import { opportunityTypeService } from "./services/opportunityTypeService";
import { opportunityMasterService } from "./services/opportunityMasterService";
import { opportunityApplicationService } from "./services/opportunityApplicationService";
import { opportunityAllocationService } from "./services/opportunityAllocationService";
import { memberInterviewRecordService } from "./services/memberInterviewRecordService";
import { opportunityApplicationInterviewService } from "./services/opportunityApplicationInterviewService";
import { entityCapService } from "./services/entityCapService";
import { mentorshipMasterService } from "./services/mentorshipMasterService";

export const store = configureStore({
  reducer: {
    // Slices
    auth: authReducer,
    allUser: allUserReducer,
    states: statesReducer,
    country: countryReducer,
    // city: cityReducer,
    allUserRole: allUserRoleReducer,
    allUserGroup: allUserGroupReducer,
    organizationMaster: organizationMasterReducer,
    entityCap: entityCapReducer,
    entityMaster: entityMasterReducer,
    sponsorMaster: sponsorMasterReducer,
    familyOfficeMaster: familyOfficeMasterReducer,
    enum: enumReducer,
    entityTypeMaster: entityTypeMasterReducer,
    investmentMandateType: investmentMandateTypeReducer,
    assetType: assetTypeReducer,
    assets: assetsReducer,
    documentType: documentTypeReducer,
    documentMaster: documentMasterReducer,
    logs: logsReducer,
    investmentMaster: investmentMasterReducer,
    dashboard: dashboardReducer,
    opportunityType: opportunityTypeReducer,
    opportunityMaster: opportunityMasterReducer,
    opportunityApplication: opportunityApplicationReducer,
    opportunityAllocation: opportunityAllocationReducer,
    memberInterviewRecord: memberInterviewRecordReducer,
    opportunityApplicationInterview: opportunityApplicationInterviewReducer,
    mentorshipMaster: mentorshipMasterReducer,

    [authService.reducerPath]: authService.reducer,
    [allUserService.reducerPath]: allUserService.reducer,
    [allUserRoleService.reducerPath]: allUserRoleService.reducer,
    [allUserGroupService.reducerPath]: allUserGroupService.reducer,
    [stateService.reducerPath]: stateService.reducer,
    [countryService.reducerPath]: countryService.reducer,
    [organizationMasterService.reducerPath]: organizationMasterService.reducer,
    [entityCapService.reducerPath]: entityCapService.reducer,
    [entityMasterService.reducerPath]: entityMasterService.reducer,
    [sponsorMasterService.reducerPath]: sponsorMasterService.reducer,
    [familyOfficeMasterService.reducerPath]: familyOfficeMasterService.reducer,
    [enumService.reducerPath]: enumService.reducer,
    [entityTypeMasterService.reducerPath]: entityTypeMasterService.reducer,
    [investmentMandateTypeService.reducerPath]: investmentMandateTypeService.reducer,
    [assetTypeService.reducerPath]: assetTypeService.reducer,
    [assetsService.reducerPath]: assetsService.reducer,
    [investmentMasterService.reducerPath]: investmentMasterService.reducer,
    [documentTypeService.reducerPath]: documentTypeService.reducer,
    [documentMasterService.reducerPath]: documentMasterService.reducer,
    [dashboardService.reducerPath]: dashboardService.reducer,
    [riskAssessmentLogService.reducerPath]: riskAssessmentLogService.reducer,
    [opportunityMasterService.reducerPath]: opportunityMasterService.reducer,
    [opportunityTypeService.reducerPath]: opportunityTypeService.reducer,
    [opportunityApplicationService.reducerPath]: opportunityApplicationService.reducer,
    [opportunityAllocationService.reducerPath]: opportunityAllocationService.reducer,
    [memberInterviewRecordService.reducerPath]: memberInterviewRecordService.reducer,

    [opportunityApplicationInterviewService.reducerPath]: opportunityApplicationInterviewService.reducer,
    [mentorshipMasterService.reducerPath]: mentorshipMasterService.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(authService.middleware)
      .concat(allUserService.middleware)
      .concat(allUserRoleService.middleware)
      .concat(allUserGroupService.middleware)
      .concat(stateService.middleware)
      .concat(countryService.middleware)
      .concat(organizationMasterService.middleware)
      .concat(entityCapService.middleware)
      .concat(entityMasterService.middleware)
      .concat(sponsorMasterService.middleware)
      .concat(familyOfficeMasterService.middleware)
      .concat(enumService.middleware)
      .concat(entityTypeMasterService.middleware)
      .concat(investmentMandateTypeService.middleware)
      .concat(assetTypeService.middleware)
      .concat(assetsService.middleware)
      .concat(investmentMasterService.middleware)
      .concat(documentTypeService.middleware)
      .concat(documentMasterService.middleware)
      .concat(dashboardService.middleware)
      .concat(riskAssessmentLogService.middleware)
      .concat(opportunityMasterService.middleware)
      .concat(opportunityTypeService.middleware)
      .concat(opportunityApplicationService.middleware)
      .concat(opportunityAllocationService.middleware)
      .concat(memberInterviewRecordService.middleware)
      .concat(opportunityApplicationInterviewService.middleware)
      .concat(mentorshipMasterService.middleware)
  ,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
